import { FC, Fragment, useContext } from 'react';
import { Card, Typography } from '@mui/material';
// components
import RowView from 'components/common/RowView';
import DataLoader from 'components/common/DataLoader';
// constants, context, graphql
import {
  NAME_TEXT,
  FORM_TEXT,
  PRODUCT_TYPE_TEXT,
  PRODUCT_FORMULATION_TEXT,
  NOTES_TEXT,
} from 'constants/index';
import { FormulaDetailContext } from 'contexts/FormulaDetailContext';

const FormulaBasicInfoCard: FC = () => {
  const { state, loading } = useContext(FormulaDetailContext);
  const { formula } = state;
  const {
    productType,
    subProductType,
    productFormulationType,

    name,
    description,
  } = formula || {};

  const { name: productTypeName } = productType || {};
  const { name: formName } = subProductType || {};
  const { name: productFormulationTypeName } = productFormulationType || {};

  return (
    <Card>
      {loading ? (
        <DataLoader columns={12} rows={6} />
      ) : (
        <Fragment>
          <RowView name={NAME_TEXT} value={name ?? ''} />
          <RowView name={PRODUCT_TYPE_TEXT} value={productTypeName ?? ''} />
          <RowView name={FORM_TEXT} value={formName ?? ''} />
          <RowView name={PRODUCT_FORMULATION_TEXT} value={productFormulationTypeName ?? ''} />
          <Typography variant="caption" component={'p'} fontWeight={700} color="customGrayColor.main" mt={2}>
            {NOTES_TEXT}
          </Typography>
          <Typography variant="caption" fontWeight={700}>
            {description || '--'}
          </Typography>
        </Fragment>
      )}
    </Card>
  );
};

export default FormulaBasicInfoCard;
